module.exports = __webpack_public_path__ + "img/logo2.c344e1ad.png";